import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { TabsSettingsFormListSection } from './TabsSettingsFormListSection';
import { TabsSettingsFormStartSection } from './TabsSettingsFormStartSection';

export type ITabsSettingsFormValues = {
  tabIds?: Array<string>;
  startTabId?: string;
  merchMMFEnabled?: boolean;
  merchWPEnabled?: boolean;
  chatEnabled?: boolean;
  leaderboardEnabled?: boolean;
};

export type ITabsSettingsFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<ITabsSettingsFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<ITabsSettingsFormValues>;
    onSubmit?: SubmitHandler<ITabsSettingsFormValues>;
  };

export const TabsSettingsForm: React.FC<ITabsSettingsFormProps> = (props) => {
  const { sx, defaultValues, onSubmit, ...other } = props;

  const form = useForm<ITabsSettingsFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody sx={sx} form={form} onSubmit={onSubmit} {...other}>
      <TabsSettingsFormListSection form={form} />
      <TabsSettingsFormStartSection form={form} />
    </ContentBlock.FormBody>
  );
};
